import { useEffect } from "react";
import { motion } from "framer-motion";

// Hoisted static motion props (avoid re-created objects on every render)
const REVEAL_VIEWPORT = { once: true, margin: "-60px" };
const REVEAL_EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={REVEAL_VIEWPORT}
    transition={{ duration: 0.8, delay, ease: REVEAL_EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export function usePageMeta(title, description) {
  useEffect(() => {
    const SITE_ORIGIN = "https://skngroup.net"; // canonical public domain (SEO only)
    document.title = title;
    const ensure = (attr, key, content) => {
      let m = document.querySelector(`meta[${attr}="${key}"]`);
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute(attr, key);
        document.head.appendChild(m);
      }
      m.setAttribute("content", content);
    };
    const ogImage = `${SITE_ORIGIN}/assets/og-image.jpg`;
    const canonicalUrl = `${SITE_ORIGIN}${window.location.pathname}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);
    ensure("name", "description", description);
    ensure("property", "og:type", "website");
    ensure("property", "og:title", title);
    ensure("property", "og:description", description);
    ensure("property", "og:image", ogImage);
    ensure("property", "og:url", canonicalUrl);
    ensure("name", "twitter:card", "summary_large_image");
    ensure("name", "twitter:title", title);
    ensure("name", "twitter:description", description);
    ensure("name", "twitter:image", ogImage);
  }, [title, description]);
}
